import request from '@/request/request'

/**
 * // 阿里云图形验证登录业务
 * @param {} parameter 
 * @returns 
 */
export function aliyunPhotoCaptchaLogin (parameter) {
  return request({
    url: '/external-service-center/aliyunPhotoCaptcha/login',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取切换企业列表
 * @param {} parameter 
 * @returns 
 */
export function listSwitchAccount (parameter) {
  return request({
    url: '/e-find-user/testLogin/listSwitchAccount',
    method: 'get',
    data: parameter
  })
}

/**
 * 切换企业
 * @param {} parameter 
 * @returns 
 */
export function switchAccount (parameter) {
  return request({
    url: '/e-find-user/testLogin/switchAccount',
    method: 'post',
    data: parameter
  })
}